import React from 'react';

const FilterButton = ({ label, value, currentFilter, onClick }) => {
    const isActive = currentFilter === value;

    return (
        <button
            onClick={() => onClick(value)}
            className={`px-5 py-2 rounded-full font-medium transition-all duration-300 ease-in-out transform ${isActive
                    ? 'bg-red-500 text-white shadow-md scale-105'
                    : 'bg-transparent text-gray-700 hover:bg-gray-100 hover:scale-105'
                }`}
        >
            {label}
        </button>
    );
};

export default FilterButton;
